export const localDateKey = date => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
export const interviewDateKey = value => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value) ? value.slice(0,10) : '';
export const isPendingInterview = interview => ['Scheduled','Invite Sent'].includes(interview.job_application_status);
export function deriveDashboardData(interviews, templates, now = new Date()) {
  const todayKey = localDateKey(now);
  const ongoing = interviews.filter(i=>i.job_application_status==='In Progress');
  const today = interviews.filter(i=>interviewDateKey(i.interviewDate)===todayKey);
  const jobs = {active:0,inactive:0,hold:0,closed:0};
  templates.forEach(t=>{const key=String(t.templateStatus || '').toLowerCase();if(Object.prototype.hasOwnProperty.call(jobs,key))jobs[key]++;});
  const candidates = {invited:0,interviewed:0,shortlisted:0,aboveBenchmark:0,belowBenchmark:0,rejected:0};
  interviews.forEach(i=>{if(i.job_application_status==='Invite Sent')candidates.invited++;if(i.job_application_status==='Completed')candidates.interviewed++;if(i.selectionStatus==='SHORTLISTED')candidates.shortlisted++;if(i.selectionStatus==='REJECTED')candidates.rejected++;if(i.candidate_selection_status==='pass')candidates.aboveBenchmark++;if(i.candidate_selection_status==='fail')candidates.belowBenchmark++;});
  return {ongoing,today,pendingToday:today.filter(isPendingInterview),upcoming:interviews.filter(i=>isPendingInterview(i)&&interviewDateKey(i.interviewDate)>todayKey),jobs,candidates,alerts:interviews.filter(i=>i.proctoringAlert===true).length,stages:{scheduled:interviews.filter(i=>i.job_application_status==='Scheduled').length,completed:interviews.filter(i=>i.job_application_status==='Completed').length}};
}

// Dashboard date drilldowns use scheduled dates, not the listing API's creation dates.
export function matchesDashboardInterviewScope(interview, scope, fromDate = '', toDate = '') {
  if (!scope.pendingOnly) return true;
  if (!isPendingInterview(interview)) return false;
  const date = interviewDateKey(interview.interviewDate);
  return Boolean(date) && (!fromDate || date >= fromDate) && (!toDate || date <= toDate);
}

// MongoDB returns UTC timestamps without an offset; preserve offsets when supplied.
export function formatInterviewStartedAt(value, timeZone) {
  if (!value) return '\u2014';
  let timestamp = value;
  if (typeof value === 'string') {
    timestamp = value.trim().replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(timestamp) && !/(Z|[+-]\d{2}:?\d{2})$/i.test(timestamp)) timestamp += 'Z';
  }
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '\u2014';
  return date.toLocaleTimeString('en-US', {hour:'2-digit',minute:'2-digit',hour12:true,...(timeZone ? {timeZone} : {})});
}
